import * as Buttons from './ui/Buttons';

const globalTinyMCE = window.tinymce;

// Vite does not always transpile arrow functions in typescript, causing an error when calling
// when tinymce calls its plugin constructor on the function.
/* eslint-disable prefer-arrow-callback */
if (globalTinyMCE) {
  globalTinyMCE.PluginManager.add('characterStyleSplit', function (editor: any) {
    Buttons.register(editor);
  });
}
/* eslint-enable prefer-arrow-callback */
